// src/hooks/useResizablePanel.js
import { useEffect, useRef, useState } from "react";


export default function useResizablePanel(minWidth = 400, maxWidthRatio = .82, initialWidth = 650) {
 const [panelWidth, setPanelWidth] = useState(initialWidth);
 const isResizing = useRef(false);


 const startResizing = () => {
   isResizing.current = true;
   document.body.style.userSelect = 'none';
 };


 const stopResizing = () => {
   isResizing.current = false;
   document.body.style.userSelect = 'auto';
 };


 const resizePanel = (e) => {
   if (isResizing.current) {
     const screenWidth = window.innerWidth;
     const maxWidth = screenWidth * maxWidthRatio;


     const newWidth = Math.min(Math.max(minWidth, e.clientX), maxWidth);
     setPanelWidth(newWidth);
   }
 };


 useEffect(() => {
   document.addEventListener('mousemove', resizePanel);
   document.addEventListener('mouseup', stopResizing);
   return () => {
     document.removeEventListener('mousemove', resizePanel);
     document.removeEventListener('mouseup', stopResizing);
   };
 }, []);


 return {
   panelWidth,
   startResizing
 };
}



